import Ponder from './Ponder';

export default Ponder;
